import { xhr } from '@/api/config/Repository'
import AdministrationRepository from '../AdministrationRepository'
import AdministrationSupplierRequest from '@/services/administration/models/AdministrationSupplierRequest'
import AdministrationSupplierResponseDTO from '../dto/AdministrationSupplierResponseDTO'
import AdministrationSupplier from '@/services/administration/models/AdministrationSupplier'
import AdministrationCountrySaveResponseDTO from '../dto/AdministrationCountrySaveResponseDTO'
import AdministrationCountryRequest from '@/services/administration/models/AdministrationCountryRequest'
import AdministrationCountryResponseDTO from '../dto/AdministrationCountryResponseDTO'
import AdministrationCountry from '@/services/administration/models/AdministrationCountry'
import AdministrationSupplierSaveResponseDTO from '../dto/AdministrationSupplierSaveResponseDTO'
import AdministrationWarehouseRequest from '@/services/administration/models/AdministrationWarehouseRequest'
import AdministrationWarehouseResponseDTO from '../dto/AdministrationWarehouseResponseDTO'
import AdministrationWarehouse from '@/services/administration/models/AdministrationWarehouse'
import AdministrationWarehouseSaveResponseDTO from '../dto/AdministrationWarehouseSaveResponseDTO'
import QualifierRequest from '@/services/administration/models/QualifierRequest'
import QualifierResponse from '@/services/administration/models/QualifierResponse'
import QualifierMappingRequest from '@/services/administration/models/QualifierMappingRequest'
import QualifierMappingResponse from '@/services/administration/models/QualifierMappingResponse'
import SLGridRequest from '@/services/administration/models/SLGridRequest'
import SLGridResponse from '@/services/administration/models/SLGridResponse'
import SLGridResponseDTO from '../dto/SLGridResponseDTO'
import SLGridModifyRequest from '@/services/administration/models/SLGridModifyRequest'
import SLGridModifyResponse from '@/services/administration/models/SLGridModifyResponse'
import AdministrationProcessLoggerRequest from '@/services/administration/models/AdministrationProcessLoggerRequest'
import AdministrationProcessLoggerResponseDTO from '../dto/AdministrationProcessLoggerResponseDTO'
export default class AdministrationRepositoryImpl implements AdministrationRepository {
  async getAdministrationSupplierData (param: AdministrationSupplierRequest): Promise<AdministrationSupplierResponseDTO> {
    const endpoint = 'admin/fetchAllSupplier'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationSupplierRequest, any>(endpoint, param, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getAdministrationSupplierSaveData (param: AdministrationSupplier): Promise<AdministrationSupplierSaveResponseDTO> {
    const endpoint = 'admin/createSupplier'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationSupplier, any>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getAdministrationSupplierEditData (param: AdministrationSupplier): Promise<AdministrationSupplierSaveResponseDTO> {
    const endpoint = 'admin/editSupplier'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<AdministrationSupplier, any>(endpoint, param, { headers })
    console.log(response)
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getAdministrationCountryData (param: AdministrationCountryRequest): Promise<AdministrationCountryResponseDTO> {
    const queryString = 'pageNumber=' + param.pageNumber + '&pageSize=' + param.pageSize + '&sortBy=' + param.sortBy + '&countryList=' + param.countryList
    const endpoint = 'admin/fetchCountry?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.get<any>(endpoint, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getAdministrationCountrySaveData (param: AdministrationCountry): Promise<AdministrationCountrySaveResponseDTO> {
    const endpoint = 'admin/createCountry'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationCountry, any>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getAdministrationCountryEditData (param: AdministrationCountry): Promise<AdministrationCountrySaveResponseDTO> {
    const endpoint = 'admin/editCountry'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<AdministrationCountry, any>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getAdministrationWarehouseData (param: AdministrationWarehouseRequest): Promise<AdministrationWarehouseResponseDTO> {
    const endpoint = 'admin/fetchAllWarehouse'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationWarehouseRequest, any>(endpoint, param, { headers })

    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getAdministrationWarehouseEditData (param: AdministrationWarehouse): Promise<AdministrationWarehouseSaveResponseDTO> {
    const endpoint = 'admin/editWarehouse'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<AdministrationWarehouse, any>(endpoint, param, { headers })
    console.log(response)
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getAdministrationWarehouseSaveData (param: AdministrationWarehouse): Promise<AdministrationWarehouseSaveResponseDTO> {
    const endpoint = 'admin/createWarehouse'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationWarehouse, any>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async addNewQualifierData (param: QualifierRequest): Promise<QualifierResponse> {
    const endpoint = 'md/saveQualifier'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<QualifierRequest, QualifierResponse>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async addQualifierMappingData (param: QualifierMappingRequest): Promise<QualifierMappingResponse> {
    const endpoint = 'qualifiergrid/addQualifierData'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<QualifierMappingRequest, QualifierMappingResponse>(endpoint, param, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }

  async getSLGridData (param: SLGridRequest): Promise<SLGridResponse> {
    const endpoint = 'qualifiergrid/getQualifierData'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<SLGridRequest, SLGridResponseDTO>(endpoint, param, { headers })

    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async modifySLGridData (entityUrl: string, param: SLGridModifyRequest): Promise<SLGridModifyResponse> {
    const endpoint = entityUrl
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<SLGridModifyRequest, SLGridModifyResponse>(endpoint, param, { headers })

    return {
      status: response.status,
      message: response.data.message
    }
  }

  async getAdministrationProcessLoggerData (param: AdministrationProcessLoggerRequest): Promise<AdministrationProcessLoggerResponseDTO> {
    const endpoint = 'france/common/processLogger'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<AdministrationProcessLoggerRequest, AdministrationProcessLoggerResponseDTO>(endpoint, param, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async downloadProcessLoggerRequest (request): Promise<any> {
    const endpoint = 'france/common/processLoggerFileDownload'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
